import PiadaOneApi from './PiadaOneApi';
import { plainToClass } from 'class-transformer';
import OrderDetails from '../classes/OrderDetails';

export default {
  getOrder(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.get(
        '/olo/orders/'+id,
        {
          headers: {
            'X-User-Verify': 'header'
          }
        },
      ).then((response) => {
        if (response.status === 200 && response.data) {
          const jsonObj = response.data as any;

          const order = plainToClass(OrderDetails, (jsonObj as object), { excludeExtraneousValues: true })

          resolve(order);
        } else {
          reject(new Error('ERROR'));
        }
      });
    });
  },
  cancelOrder(orderGuid: string): Promise<any> {
    return new Promise((resolve, reject) => {
      PiadaOneApi.post(
        '/olo/orders/'+orderGuid+'/cancel',
        {
          headers: {
            'X-User-Verify': 'header'
          }
        },
      ).then((response) => {
        if (response.status === 200 && response.data && response.data.status && response.data.status.toLowerCase().includes("cancel")) {
          const jsonObj = response.data as any;

          const order = plainToClass(OrderDetails, (jsonObj as object), { excludeExtraneousValues: true })

          resolve(order);
        } else {
          reject(new Error('Your order could not be canceled.'));
        }
      });
    });
  },
};
